import { render, staticRenderFns } from "./RedirectSection.vue?vue&type=template&id=72486f50&scoped=true&"
import script from "./RedirectSection.vue?vue&type=script&lang=ts&"
export * from "./RedirectSection.vue?vue&type=script&lang=ts&"
import style0 from "./RedirectSection.vue?vue&type=style&index=0&id=72486f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72486f50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
